export default "__VITE_ASSET__e5U7P6Ot__"